'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  backgroundColor: _propTypes2.default.string
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var backgroundColor = _ref.backgroundColor,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['backgroundColor', 'style']);

  var newStyles = {};

  newStyles.backgroundColor = backgroundColor;

  return _extends({ style: _extends({}, newStyles, style) }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvYmFja2dyb3VuZENvbG9yLmpzIl0sIm5hbWVzIjpbInByb3BUeXBlcyIsImJhY2tncm91bmRDb2xvciIsInN0cmluZyIsInBhcnNlUHJvcHMiLCJzdHlsZSIsInByb3BzIiwibmV3U3R5bGVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7QUFFTyxJQUFNQSxnQ0FBWTtBQUN2QkMsbUJBQWlCLG9CQUFVQztBQURKLENBQWxCOztBQUlBLElBQU1DLGtDQUFhLFNBQWJBLFVBQWEsT0FBMEM7QUFBQSxNQUF2Q0YsZUFBdUMsUUFBdkNBLGVBQXVDO0FBQUEsTUFBdEJHLEtBQXNCLFFBQXRCQSxLQUFzQjtBQUFBLE1BQVpDLEtBQVk7O0FBQ2xFLE1BQU1DLFlBQVksRUFBbEI7O0FBRUFBLFlBQVVMLGVBQVYsR0FBNEJBLGVBQTVCOztBQUVBLG9CQUFTRyxvQkFBWUUsU0FBWixFQUEwQkYsS0FBMUIsQ0FBVCxJQUErQ0MsS0FBL0M7QUFDRCxDQU5NIiwiZmlsZSI6ImJhY2tncm91bmRDb2xvci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcblxuZXhwb3J0IGNvbnN0IHByb3BUeXBlcyA9IHtcbiAgYmFja2dyb3VuZENvbG9yOiBQcm9wVHlwZXMuc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBwYXJzZVByb3BzID0gKHsgYmFja2dyb3VuZENvbG9yLCBzdHlsZSwgLi4ucHJvcHMgfSkgPT4ge1xuICBjb25zdCBuZXdTdHlsZXMgPSB7fVxuXG4gIG5ld1N0eWxlcy5iYWNrZ3JvdW5kQ29sb3IgPSBiYWNrZ3JvdW5kQ29sb3JcblxuICByZXR1cm4geyBzdHlsZTogeyAuLi5uZXdTdHlsZXMsIC4uLnN0eWxlIH0sIC4uLnByb3BzIH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/backgroundColor.js
// module id = 1141
// module chunks = 0